import { callApi } from './ApiClient';

const getExecutiveListFilters = (data = null, dispatch) => {
  return callApi('GET', `/executive_list_filters`, data, dispatch);
}

const postExecutiveListFilters = (data, dispatch) => {
  return callApi('POST', `/executive_list_filters`, data, dispatch);
}

const patchExecutiveListFiltersById = (id, data, dispatch) => {
  return callApi('PATCH', `/executive_list_filters/${id}`, data, dispatch);
}

const deleteExecutiveListFiltersById = (id, dispatch) => {
  return callApi('DELETE', `/executive_list_filters/${id}`, null, dispatch);
}

export const ExecutiveListFiltersApi = {
  getExecutiveListFilters,
  postExecutiveListFilters,
  patchExecutiveListFiltersById,
  deleteExecutiveListFiltersById,
};



// WEBPACK FOOTER //
// ./src/redux/api/ExecutiveListFiltersApi.js